var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-player"},[_c('IframeAux',{staticClass:"playerIFrame",attrs:{"isMobile":_vm.isMobile,"id":"iframe-player2","source":_vm.source}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }